import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CardLayout from '../../components/utils/CardLayout';
import { useForm } from "react-hook-form";
import Button from '../../components/utils/Button';
import msisdnPoolActions from '../../redux/msisdnPool/actions'
import Table from '../../components/utils/Table';
import Tag from '../../components/utils/Tag';
import moment from 'moment';
import { Link } from 'react-router-dom';
import DeleteBin5Fill from 'remixicon-react/DeleteBin5FillIcon';
import Modal from '../../components/utils/Model'
import authActions from '../../redux/auth/actions';
import useSocket from '../../hooks/useSocket'
import { isAdmin, isAdminAgent, convertDateToRequiredFormatTZ } from '../../helpers/commonFunction';
import Alert from '../../components/utils/Alert'
import SocketActions from '../../redux/socket/actions'
import DatePicker from "react-datepicker";
import Calendar2LineIcon from 'remixicon-react/Calendar2LineIcon';

const { getMsisdnPool, resetSearchData, getShortCodeData, prepareMsidnForm, resetMsisdn, removeMsisdnFromPool } = msisdnPoolActions;
const { getUserDataByToken } = authActions;
const { getMsisdnPoolForSocketList } = SocketActions;

const MsisdnPool = () => {
    const dispatch = useDispatch();
    const { tokenData } = useSelector((state) => state.auth);
    const [availablityDate, setAvailablityDate] = useState(moment().tz(process.env.REACT_APP_DISPLAY_TIMEZONE).startOf('day').toDate());
    const datePickerRef = useRef(null);
    const { getMsisdnPoolResult, tableLoading, buttonLoading, shortCodeData, msisdnFormModal, msisdnPoolError, msisdnPoolMessage } = useSelector((state) => state.msisdnPool);
    const [searchData, setSearchData] = useState({
        statusID: "41",
        MSISDN: "",
        AvailabilityDate: moment(availablityDate).format("YYYY-MM-DD"),
    })
    const [statusData, setstatusData] = useState({
        tableName: "msisdn",
        fieldName: "Status"
    });
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [buttonText, setButtonText] = useState();
    const [formTitle, setFormTitle] = useState('');
    const [msisdnId, setMsisdnId] = useState(0);
    const [remarkContent, setRemarkContent] = useState({
        remark: '',
    });

    const { register, handleSubmit, formState: { errors }, control: searchControl, watch } = useForm({
        defaultValues: searchData,
    });

    const { register: registerRegister, handleSubmit: handleMsisdnSubmit, formState: { errors: errorError }, reset } = useForm({
        defaultValues: remarkContent
    });

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [formData, setFormData] = useState('');
    const [selectedMSISDN, setSelectedMSISDN] = useState('');


    useSocket('remove msisdn from pool', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getMsisdnPoolForSocketList(searchData));
        }
    });

    // const msisdnWatch = watch('MSISDN');
    // const statusWatch = watch('statusID');s

    useEffect(() => {
        dispatch(getShortCodeData(statusData));
        dispatch(getMsisdnPool(searchData));
    }, [])

    useEffect(() => {
        if (msisdnPoolMessage !== null && msisdnPoolMessage !== undefined) {
            displayAlert(msisdnPoolMessage, 'alert-success');
            reset();
        }
        if (msisdnPoolError !== null && msisdnPoolError !== undefined) {
            displayAlert(msisdnPoolError, 'alert-danger');
            reset();
        }
    }, [msisdnPoolMessage, msisdnPoolError]);

    let columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'MSISDN', key: 'msisdn' },
        { displayName: 'SERIAL NUMBER', key: 'curSerialNumber' },
        { displayName: 'EMAIL', key: 'email' },
        { displayName: 'PLAN', key: 'planName' },
        { displayName: 'ADDON', key: 'addonName' },
        { displayName: 'CREATED DATE', key: 'createdDate' },
        { displayName: 'EXPIRY DATE', key: 'expiryDate' },
        { displayName: 'REMAINING DAYS', key: 'remainingDays' },
        { displayName: 'STATUS', key: 'status' },
        { displayName: 'ACTION', key: 'action' },
    ];

    const handleEditMSISDNModal = (data) => {
        setMsisdnId(data.ID);
        setFormTitle(`Remove MSISDN (${data.MSISDN})`);
        setSelectedMSISDN(data.MSISDN);
        setButtonText('Update');
        dispatch(prepareMsidnForm());
    }

    const handleCancel = () => {
        dispatch(resetMsisdn());
        reset();
    }

    const dataSource = getMsisdnPoolResult && getMsisdnPoolResult.length > 0 && getMsisdnPoolResult.map((data, key) => {
        return {
            key: key + 1,
            msisdn: data.MSISDN,
            curSerialNumber: data.CurSerialNumber,
            planName: data.PlanName ?? '',
            addonName: data.AddonName ?? '',
            createdDate: data.CreatedDtTm !== null ? convertDateToRequiredFormatTZ(data.CreatedDtTm) : '',
            expiryDate: data.ExpiryDate !== null ? convertDateToRequiredFormatTZ(data.ExpiryDate) : '',
            status: <Tag
                color={`${(data.StatusId === 41) ? 'badge-success' : (data.StatusId === 42) ? 'badge-primary' : (data.StatusId === 43) ? 'badge-danger' : (data.StatusId === 44 || data.StatusId === 54) ? 'badge-secondary' : 'badge-warning'}`}
                title={data.StatusType}
            />,
            email: data.CustomerEmail,
            action: (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Link to="#" onClick={() => handleEditMSISDNModal(data)}>
                        <span data-toggle="tooltip" data-placement="top" title="Remove MSISDN">
                            <DeleteBin5Fill size="1.2em" style={{ color: "#f14336" }} />
                        </span>
                    </Link>
                </div>
            ),
            remainingDays: data.RemainingDays,
        }
    });

    const onSubmit = (data) => {
        data.AvailabilityDate = moment(availablityDate).format("YYYY-MM-DD");
        setSearchData(data);
        dispatch(getMsisdnPool(data))
    }

    const handleMSISDNSubmit = (data) => {
        setFormData(data);
        setShowConfirmModal(true);
    };

    const handleConfirmSubmit = () => {
        if (formData) {
            const newData = {
                ...formData,
                mdnId: msisdnId,
                MSISDN: selectedMSISDN
            }
            dispatch(removeMsisdnFromPool(newData, searchData));
            setShowConfirmModal(false);
        }
    };


    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        dispatch(resetMsisdn());
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMsisdn());
    }

    const openDatePicker = () => {
        datePickerRef.current.setOpen(true);
    };


    return (
        <CardLayout title="MSISDN Pool">
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-row">
                    <div className="col-lg-3 col-md-4 mb-2">
                        <label>Select Status</label>
                        <select className="form-control" id="statusID" name="statusID" placeholder="Select"  {...register("statusID", {
                        })} >
                            {/* <option value="" name="All">All</option>
                            {shortCodeData && shortCodeData.length > 0 && shortCodeData.map((item, ind) => (
                                <option value={item.ID} name={item.Value}>{item.Value}</option>
                            ))} */}
                            {shortCodeData && shortCodeData.length > 0 && <option value="" name="All">All</option>}
                            <option value={'41'} name={'Free'}>Free</option>
                            {shortCodeData && shortCodeData.length > 0 && shortCodeData.filter(item => item.ID != 41).map((item, ind) => (
                                <option value={item.ID} name={item.Value}>{item.Value}</option>
                            ))}
                        </select>

                    </div>
                    <div className="col-lg-3 col-md-4 mb-2">
                        <label>MSISDN</label>
                        <input
                            type="number"
                            className="form-control"
                            id="MSISDN"
                            name="MSISDN"
                            placeholder="MSISDN"
                            {...register("MSISDN", {
                                required: false,
                            })}
                        />
                    </div>

                    <div className="col-lg-3 col-md-4 mb-2 d-flex flex-column">
                        <label>Availability Date</label>
                        <Calendar2LineIcon onClick={openDatePicker} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                        <DatePicker
                            ref={datePickerRef}
                            selected={availablityDate}
                            // minDate={moment().tz(process.env.REACT_APP_DISPLAY_TIMEZONE).startOf('day').toDate()}
                            className="form-control center"
                            onChange={(date) => {
                                console.log('Selected date:', date);
                                setAvailablityDate(date);
                            }}
                            dateFormat="yyyy-MM-dd"
                            name="AvailabilityDate"
                            showMonthDropdown
                            showYearDropdown
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            value={availablityDate}
                        />
                    </div>

                    <div className={'col-lg-2 col-md-4'}>
                        <div className={"mt-2 d-flex justify-content-start activation-search-btn"}>
                            <Button title="Search" loading={buttonLoading} style="minWidth:80px" buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                        </div>
                    </div>

                </div>
            </form>
            <Table columns={columns} data={dataSource} loading={tableLoading} pagination={true} />

            {/* Remove MSISDN MODEL */}
            <Modal
                showModal={msisdnFormModal}
                title={formTitle}
                onHide={handleCancel}
                width={600}
                showFooter={false}
            >
                <form onSubmit={handleMsisdnSubmit(handleMSISDNSubmit)}>
                    <div className="form-row">
                        <div className="col-md-12 mb-3">
                            <label>Remark</label>
                            <textarea className="form-control" placeholder="Enter Remark" id="remark" name="remark" rows="3" cols="30" {...registerRegister("remark", {
                                required: true
                            })}>
                            </textarea>
                            {errorError.remark?.type === "required" && (
                                <div className="invalid-feedback">Remark required !</div>
                            )}
                        </div>
                    </div>
                    <hr />
                    <div className='text-right row'>
                        <div className="col-md-12">
                            <button type="button" className="btn btn-secondary mr-2" onClick={handleCancel}>Close</button>
                            <Button title={buttonText} style="minWidth:80px" loading={false} buttonClass="btn btn-primary" buttonType='submit' />
                        </div>
                    </div>
                </form>

            </Modal>

            <Modal
                showModal={showConfirmModal}
                title="Are you Sure"
                onHide={() => setShowConfirmModal(false)}
                width={400}
                showFooter={false}
            >
                <p>
                    You want to remove this MSISDN: <strong>{selectedMSISDN}</strong>?
                </p>
                <div className="text-right">
                    <button className="btn btn-secondary mr-2" onClick={() => setShowConfirmModal(false)}>No</button>
                    <Button title="Yes" style="minWidth:80px" loading={buttonLoading} buttonClass="btn btn-primary" onClick={handleConfirmSubmit} />
                </div>
            </Modal>


        </CardLayout>
    )
}

export default MsisdnPool;